import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { WidgetCard } from '../WidgetCard';
import { Popup } from 'semantic-ui-react';
import { widgetHeight, widgetWidth } from '..';
import { BottomButtonRow, Message } from '../Styles';
import ButtonWithConfirmation from '../ButtonWithConfirmation';
import useStores from '../../../../hooks/use-store';
import { engineToolType } from '../../../../stores/reducers/engineTools';

export const EngineResetCacheWidget = observer(() => {
  const {
    EngineToolStore: { enginePost: post, widgetReloading },
  } = useStores();

  const [message, setMessage] = useState(null);
  const [success, setSuccess] = useState(null);

  const statusMessageHandler = ({ success, message }) => {
    setMessage(message);
    setSuccess(success);
  };

  const handleConfirmation = (e) => {
    e.preventDefault();
    post(engineToolType.resetEngineCache).then(statusMessageHandler);
  };

  const isLoading = widgetReloading[engineToolType.resetEngineCache];

  return (
    <WidgetCard
      heading="Reset Cache"
      description="Clears out ALL cached SQL queries and forces the Engine to reload data directly from the Database the next time data is requested."
      width="450px"
      height="235px"
    >
      <BottomButtonRow buttonWidth="150px">
        {message ? (
          <Popup
            data-testid="engine-cache-reset-popup"
            key="engine-cache-reset"
            content={message}
            header="Details"
            size="small"
            trigger={
              <Message success={success}>
                {success
                  ? '😃 The engine cache has been successfully reset!'
                  : '🤔 Oops, an error occurred while trying to reset the engine cache.'}
              </Message>
            }
          />
        ) : (
          <Message />
        )}
        <ButtonWithConfirmation
          buttonText="Reset Cache"
          buttonIcon="sync"
          onConfirmation={handleConfirmation}
          loading={isLoading}
        />
      </BottomButtonRow>
    </WidgetCard>
  );
});

export default EngineResetCacheWidget;
